import type { MittwaldAPIV2 } from "@mittwald/api-client-NEXT";

export type ContainerData =
  MittwaldAPIV2.Components.Schemas.ContainerServiceResponse;

export type ContainerStackData =
  MittwaldAPIV2.Components.Schemas.ContainerStackResponse;

export type ContainerListItemData =
  MittwaldAPIV2.Operations.ContainerListServices.ResponseData[number];

export type ContainerListQueryData =
  MittwaldAPIV2.Paths.V2ProjectsProjectIdServices.Get.Parameters.Query;

export type ContainerPatchRequestData =
  MittwaldAPIV2.Paths.V2StacksStackId.Patch.Parameters.RequestBody;

export type ContainerStatus =
  MittwaldAPIV2.Components.Schemas.ContainerServiceStatus;

export interface ContainerUpdateData {
  description?: string;
  image?: string;
}

export type ContainerVolumeRelationData = string;

export type ContainerPortData = string;

export interface ContainerEnvVariableData {
  key: string;
  value: string;
}

export type ImageMetaEnvData =
  MittwaldAPIV2.Components.Schemas.ContainerContainerImageConfigEnv;

export type ImageMetaPortData =
  MittwaldAPIV2.Components.Schemas.ContainerContainerImageConfigExposedPort;

export type ImageMetaVolumeData =
  MittwaldAPIV2.Components.Schemas.ContainerContainerImageConfigVolume;

export type ContainerStateData =
  MittwaldAPIV2.Components.Schemas.ContainerServiceState;

export type ContainerEnvVariableListData = Record<string, string>;

export type ImageMetaData =
  MittwaldAPIV2.Components.Schemas.ContainerContainerImageConfig;

export interface ContainerVolumeRelationFormValues {
  type: "directory" | "volume";
  volume: string;
  projectDirectory: string;
  containerPath: string;
}

export const containerPortRegExp = /^([0-9]+)(:[0-9]+)?(\/(tcp|udp))?$/;
export const containerFilePathRegex = /^\/[a-z,A-Z/\-_.0-9]+/;
export const containerServiceNameRegex = /[a-zA-Z0-9][a-zA-Z0-9_.-]+/;
export const containerEnvValueRegex = /^[-._a-zA-Z0-9]+$/;
export const containerMaxPort = 65535;
